import { getOrderById as fetchOrderById } from "../../services/order.api";

export {
  cancelOrder,
  initiateEpsPayment,
  initiateStripePayment,
} from "../../services/order.api";
export {
  getMyOrderReview,
  submitReview,
  updateReview,
} from "../../services/review.api";

export const getOrderById = async (id) => {
  try {
    return await fetchOrderById(id);
  } catch (error) {
    console.error("Error fetching order by id:", error);
    return null;
  }
};
